import { Injectable, SecurityContext } from '@angular/core';
import { Router, CanActivate, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { ApiLoginService } from '../services/api-login.service';
import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(
    private route: ActivatedRoute,
    private _router: Router,
    private _apiLoginService: ApiLoginService,
    private cookieService: CookieService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot) {

    var currentPath = route.url[0].path;
//    console.log("Path = " + currentPath);
    if(route.url[1]!=undefined) {
      var currentSubPath = route.url[1].path;
//      console.log("Path2 = " + currentSubPath);
    }

    /* REVIEW DOCCHECK INFO */
/*    console.log(route.queryParams.dc);
    console.log(route.queryParams.dc_timestamp);
    console.log(route.url[0].path);*/

//    console.log("Logged?="+this._apiLoginService.isAuthenticated());

    if(route.queryParams.dc!=undefined && route.queryParams.dc_timestamp!=undefined) { /* Create Cookie Login */
      if(route.url[1]==undefined) {
        this.cookieService.set(route.url[0].path, route.url[0].path);
      } else {
        this.cookieService.set(route.url[1].path, route.url[1].path);
      }
    }

    // UPDATE: ONE COOKIE FOR ALL LOGINS
    if(route.url[1]==undefined) {
      if(route.url[0].path == "therapie" || route.url[0].path == "infocenter" || route.url[0].path == "education") {
          if(this.cookieService.get('therapie')!="" || this.cookieService.get('infocenter')!="" || this.cookieService.get('education')!="" || this.cookieService.get('kardiologie')!="" || this.cookieService.get('nephrologie')!="" || this.cookieService.get('neurologie')!="") {
              return true;
          } else {
          }
      }
    } else {
      if(route.url[1].path == "kardiologie" || route.url[1].path == "nephrologie" || route.url[1].path == "neurologie") {
        if(this.cookieService.get('kardiologie')!="" || this.cookieService.get('nephrologie')!="" || this.cookieService.get('neurologie')!="") {
            return true;
        } else {
        }
      }
    }

    if(route.url[1]==undefined) {
      this._router.navigate([`/${currentPath}-login`]); // IF LOGIN NOT OK
    } else {
      this._router.navigate([`${currentPath}/${currentSubPath}-login`]); // IF LOGIN NOT OK
    }


    // OLD: ONE COOKIE FOR EACH LOGIN - LOGINS NEED IT FOR EACH LOGIN PAGE
/*    if(route.url[0].path == "therapie") {
//        console.log(this.cookieService.get('therapie'));
        if(this.cookieService.get('therapie')!="") {
//            console.log("Logged");
            return true;
        } else {
//            console.log("Not Logged");
        }
    }
    if(route.url[0].path == "infocenter") {
//        console.log(this.cookieService.get('infocenter'));
        if(this.cookieService.get('infocenter')!="") {
            return true;
        }
    }
    if(route.url[0].path == "education") {
//        console.log(this.cookieService.get('education'));
        if(this.cookieService.get('education')!="") {
            return true;
        }
    }*/

    // OLD LOGIN CHECKUP
/*    if(this._apiLoginService.isAuthenticated()){
        return true;
    } else {
//        this._router.navigate([`/${currentPath}-login`]);
      return false;
    }*/
  }





}
